module.exports = __webpack_public_path__ + "img/gyant_xl_dark_brown_ba_detail_rsh3.3ac63884.jpg";